import React, { Component, useRef, forwardRef } from 'react';
import { useSelector, useDispatch, connect } from 'react-redux';
import '../../../../styles/mainContents.css'

const InventoryDetailPrintPage = forwardRef(function PrintPage(props, ref) {
    const { inventoryDetailState} = props;

    var maxRowsPerPage = 15;
    var rowCountPerPage = 0;
    var listTotal = inventoryDetailState.length
    
    let itemList = inventoryDetailState.map((item,index)=>{
        rowCountPerPage += 1

        return (
            rowCountPerPage % maxRowsPerPage === 0 && rowCountPerPage < listTotal ? 
            (
                <tbody className='printpage_data' key={index + '_pageBreak'}>
                    <tr >                                                                             
                        <td>{item['LINE']}</td>
                        <td>{item['PARTNO']}</td>
                        <td>{item['TRANSFER_IN']}</td>
                        <td>{item['TRANSFER_OUT']}</td>
                        <td>{item['ORDER_OUT']}</td>
                        <td>{item['ONHAND']}</td>
                        <td>_____</td>
                        <td>{item['LAST_RECEIPT']}</td>                                    
                    </tr> 
                                        
                    <tr><td className='pageBreakCL'></td></tr>
                    <tr><td className='pageBreak_after'></td></tr>
                </tbody>                
            ) : 
            (
                <tbody className='printpage_data' key={index}>
                    <tr >                                                                             
                        <td>{item['LINE']}</td>
                        <td>{item['PARTNO']}</td>
                        <td>{item['TRANSFER_IN']}</td>
                        <td>{item['TRANSFER_OUT']}</td>
                        <td>{item['ORDER_OUT']}</td>
                        <td>{item['ONHAND']}</td>
                        <td>_____</td>
                        <td>{item['LAST_RECEIPT']}</td>                                    
                    </tr> 
                </tbody>
            )
        )
    })
    
    return (
        <table ref={ref} className='printpage'>
            <thead>
                <tr>
                    <th colSpan="8">
                        Inventory Detail - Loc {inventoryDetailState[0]['LOC']} - {new Date().toLocaleString()}
                    </th>
                </tr>
                <tr key='header'>
                    <th>LINE</th>
                    <th>PARTNO</th>
                    <th>TRANSFER_IN</th>
                    <th>TRANSFER_OUT</th>        
                    <th>ORDER_OUT</th> 
                    <th>ONHAND</th> 
                    <th>COUNT</th> 
                    <th>LAST_TRANSFER</th>                                                                                                                                                                              
                </tr>                
            </thead>
            {itemList}                 
        </table>
    );
})


const mapStateToProps = (state) => {
   return {
    inventoryDetailState: state.inventory['items_fetchInventoryDetail'],  
    //  authreducerState: state.authreducer
   }
  
};
  
const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryDetailPrintPage);